import React, { useState, useEffect } from "react";

export default function VideoOverlay() {
  const [isMinimized, setIsMinimized] = useState(false);

  // ✅ Check if user has already seen the overlay
  useEffect(() => {
    const hasSeenOverlay = localStorage.getItem("hasSeenOverlay");
    if (hasSeenOverlay === "true") {
      setIsMinimized(true);
    }
  }, []);

  // ✅ When minimized, store that state so it won’t reopen automatically next time
  const handleMinimize = () => {
    setIsMinimized(true);
    localStorage.setItem("hasSeenOverlay", "true");
  };

  const handleExpand = () => {
    setIsMinimized(false);
  };

  return (
    <>
      {!isMinimized ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            transition: "opacity 0.6s ease-in-out",
            cursor: "pointer",
          }}
          onClick={handleMinimize}
        >
          {/* Background video */}
          <video
            autoPlay
            loop
            playsInline
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: -1,
            }}
          >
            <source src="/visuals/intro.mp4" type="video/mp4" />
          </video>

          {/* Center text box */}
          <div
            style={{
              backgroundColor: "rgba(0, 0, 0, 0)",
              padding: "30px 60px",
              color: "white",
              fontSize: "1rem",
              textAlign: "justify",
              textAlignLast: "center",
              maxWidth: "600px",
              backdropFilter: "blur(4px)",
              fontFamily: "monospace",
              lineHeight: "2rem"
            }}
          >
            <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
              FASHION CIRCUIT MAP
            </h1>
            <p>
               As a result of passive consumer ignorance, the products displayed in shiny storefronts 
               amidst hotbeds of consumption have been obscured from their creators' hands. Our 
               purpose is to return humanity to production stories and contextualising them within the 
               supply chain.<br/><br/>This platform creates a destigmatised and equal playing field where
              each story holds the same weight and significance.<br/>
              <br />
              We rear our head from hierarchy and refuse to be satisfied with isolated coverage of
              singular individuals whose ‘genius’ is separated from, yet synonymous with, the 
              collective body of workers who labour together to produce the bedrock of our culture.
            </p>
          </div>
        </div>
      ) : (
  <div
    onClick={handleExpand}
    title="Reopen intro"
    style={{
      position: "fixed",
      bottom: "10px",
      left: "10px",
      width: "30px",
      height: "30px",
      borderRadius: "50%",
      background: "url('https://upload.wikimedia.org/wikipedia/commons/e/e1/FullMoon2010.jpg') no-repeat center/cover",
      animation: "spin 12s linear infinite",
      boxShadow: "0 0 15px rgba(255,255,255,0.4)",
      cursor: "pointer",
      zIndex: 9999,
      transition: "transform 0.3s ease, opacity 0.3s ease",
      opacity: 0.9,
    }}
    onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
    onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.9)}
  />
)}
{/* ✅ Inline keyframes for spinning moon */}
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}
